import { post, get } from '../../../../services/request';

// Get Provider List (with filters)
export const getAllRadList = (filters) => {
    return post('Radiologist/GetAllRadiologists', {
        RadType: filters.RadType || null,
        MatrixRadStatus: filters.MatrixRadStatus || null,
        SubSpeciality: filters.SubSpeciality || null,
        UserId: filters.UserId || null
    });
};

// Get Dropdown Filter Data
export const getDropdownFilterData = () => {
    return get('Radiologist/GetRadiologistAllDDList');
};